<template>
    <section class="small-left">
        <div class="center gray">

            <lottie :name="'chapter-4/usecase-04'" :width="500" :height="745" />

        </div>
        <div class="spacing center">

            <div>

                <h2>Personalized voice activated IoT services</h2>

                <p>With this use case you can offer IoT voice activation for smart homes and work spaces. The user places an IMS call to remotely control smart home assets. This calls for developers to design service logic that initiates the required smart home or smart enterprise functions.</p>

                <a href="https://www.nokia.com/networks/solutions/voice-over-5g-vo5g-core/#5g-ecosystem" class="button" target="_blank">Discover the usecase</a>

            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>